import Vue from 'vue'
import Vuex from 'vuex'
import List from './list'
import Site from './site'
import User from './user'


Vue.use(Vuex)

// 全局store
const store = new Vuex.Store({
	modules: {
		User,
		Site,
		List
	}
})

export default store

